import React from 'react';
import HeroPhoto from "../../Assets/top-header.png";

export const Hero = () => {
  const userData = JSON.parse(localStorage.getItem("user"));
  return (
    <div
      className="relative py-10 bg-gradient-to-r z-0 from-blue-500 via-blue-600 to-blue-700 rounded-sm shadow-lg"
      style={{
        backgroundImage: `url(${HeroPhoto})`, // Use template literal to set the background image
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-30 rounded-b-lg"></div>
      <div className="relative w-full px-6 py-8 z-0">
        <div className="flex flex-wrap justify-between items-start w-full flex-col">
            <h1 className="text-3xl font-bold text-darkTextColor drop-shadow-md">
              Hello Mr. {userData?.name}!
            </h1>
            <p className="mt-2 text-lg text-gray-200 drop-shadow-sm">
              See the impact of your website with detailed statistics.
            </p>
        </div>
      </div>
    </div>
  );
};
